import axios from "./axios";

export const loginUser = async (username, password) => {

  const response = await axios.post("/api/users/login/", {username, password})

  return response.data
};

export const refreshToken = async (refresh) => {
  const response = await axios.post("/api/users/token/refresh/", {refresh})

  return response.data
};

export const logoutUser = async (refresh) => {
  const response = await axios.post("/api/users/logout/", {refresh})

  return response.data
}

export const sendForgotPasswordOTP = async (userId) => {
  const response = await axios.post("/api/users/forgot-password/send-otp/", {
    user_id: userId
  })
  return response.data
}

export const verifyForgotPasswordOTP = async (userId, otp) => {
  const response = await axios.post("/api/users/forgot-password/verify-otp/", {
    user_id: userId,
    otp
  })
  return response.data
}

export const resetPassword = async (userId, otp, newPassword) => {
  const response = await axios.post("/api/users/forgot-password/reset/", {
    user_id: userId,
    otp,
    new_password: newPassword
  })
  return response.data
}